import { useTranslation } from 'react-i18next';
import { Recipient } from '../../../../models/parcelDeliveryMiles';
import { formatDocumentValue } from '../../../parcel-creation/receiver-details-summary/receiver-details-summary.component';
import NameValueSection from './name-value-section';
import DeliveryDetail from './delivery-detail.component';

interface Props {
  title: string;
  subject: Recipient | null;
  trackingNumber?: string;
}

const ParticipantPanel = ({ title, subject, trackingNumber }: Props) => {
  const { t } = useTranslation();
  const fullName = [
    subject?.first_name,
    subject?.middle_name,
    subject?.last_name,
  ]
    .filter(Boolean)
    .join(' ');
  const phone = subject?.phone?.phone_number;
  const additionalPhone =
    typeof subject?.contact_phone_number === 'string'
      ? subject.contact_phone_number
      : undefined;
  const formatPhone = (value: string) => `+${value.replace(/^\+/, '')}`;
  const location = [
    subject?.country_name,
    subject?.address?.region || subject?.address?.city,
  ]
    .filter(Boolean)
    .join(', ');
  const service = [
    subject?.carrier?.delivery_carrier_name,
    subject?.carrier?.delivery_service_name,
  ]
    .filter(Boolean)
    .join(' ');
  const summary = [fullName, location, service].filter(Boolean).join(' · ');

  return (
    <NameValueSection
      title={title}
      summary={summary || t('no_info')}
      items={
        subject
          ? [
              { name: t('full_name'), value: fullName },
              {
                name: t('phone_number'),
                value: phone ? formatPhone(phone) : '',
              },
              {
                name: t('additional_phone_number'),
                value: additionalPhone ? formatPhone(additionalPhone) : '',
              },
              { name: t('email'), value: subject.email },
              ...(subject.documents_summary?.map((document) => ({
                name: document.title,
                value: formatDocumentValue(document.value, document.type),
              })) ?? []),
            ].filter((item) => !!item.value)
          : undefined
      }>
      {subject && (
        <div className='participant-delivery'>
          <DeliveryDetail
            subject={subject}
            trackingNumber={trackingNumber}
          />
        </div>
      )}
    </NameValueSection>
  );
};

export default ParticipantPanel;
